import { UserType } from '../types';

export type ServerUserType = UserType & {
  avatar?: string;
};

function UserTypeToServerUserTypeAdapter(user: UserType): ServerUserType {
  let avatarUrl: string | undefined = user.avatar;

  if (avatarUrl) {
    const serverUserType: ServerUserType = {
      ...user,
      ...{ avatar: avatarUrl },
    };
    return serverUserType;
  }
  return user as ServerUserType;
}

export default UserTypeToServerUserTypeAdapter;
